// This file is auto-generated by @hey-api/openapi-ts

import type {
  Options as ClientOptions,
  TDataShape,
  Client,
} from '@hey-api/client-fetch';
import type {
  GetRecipientData,
  GetRecipientResponse2,
  TriggerTransactionMailData,
  TriggerTransactionSmsData,
  TriggerTransactionSmsResponse,
  TriggerTransactionSmsError,
  AddRecipientData,
  UnsubscribeRecipientData,
  UpdateRecipientData,
} from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Gets recipient from specific lsit
 * This endpoint is used to get all information for an email adress.
 * Alot of possible response fields are currently not in use.
 *
 */
export const getRecipient = <ThrowOnError extends boolean = false>(
  options: Options<GetRecipientData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetRecipientResponse2,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/get-recipient',
    ...options,
  });
};

/**
 * Sends an email to the recipient
 * This endpoint is used to trigger a transactional mail for example to edit preferences.
 *
 */
export const triggerTransactionMail = <ThrowOnError extends boolean = false>(
  options: Options<TriggerTransactionMailData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/trigger-transaction-mail',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    },
  );
};

/**
 * Sends a sms to the recipient
 * This endpoint is used to trigger a transactional sms.
 *
 */
export const triggerTransactionSms = <ThrowOnError extends boolean = false>(
  options: Options<TriggerTransactionSmsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    TriggerTransactionSmsResponse,
    TriggerTransactionSmsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/trigger-transaction-sms',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Adds new recipient to list
 * This endpoint is used to add a new recipient to the recipientList.
 *
 */
export const addRecipient = <ThrowOnError extends boolean = false>(
  options: Options<AddRecipientData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/add-recipient',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    },
  );
};

/**
 * Unsubscibes recipient
 */
export const unsubscribeRecipient = <ThrowOnError extends boolean = false>(
  options: Options<UnsubscribeRecipientData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/unsubscribe-recipient',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    },
  );
};

/**
 * Unsubscibes recipient
 */
export const updateRecipient = <ThrowOnError extends boolean = false>(
  options: Options<UpdateRecipientData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/update-recipient',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    },
  );
};
